import React from "react";
import IconBase, { IconBaseProps } from "./IconBase";

const IconVaccination: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 19 18"
      {...props}
    >
      <path
        d="M4.71924 11.5958L7.19411 14.0707"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3.9126 10.7893L7.90112 14.7778"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.37305 13.3291L5.36157 17.3176"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.53906 13.7759L4.7536 11.6304"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.97949 16.2162L7.19403 14.0707"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.71901 11.5959L11.4365 4.87836"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.19411 14.0707L13.9116 7.35321"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.4095 4.92083L14.3607 4.32689L13.9178 7.32309"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.067 4.62335L16.6328 2.0575"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </IconBase>
  );
};

export default IconVaccination;
